import { FormField } from "common/models";
import { isUndefined } from "util";

export const Rules = {
    required: (field: FormField, fieldSet?: FormField[]) => {
        let failed = false;

        if (field.value === null || isUndefined(field.value)) {
            failed = true;
        } else if (field.value instanceof Array && field.value.length < 1) {
            failed = true;
        } else if (
            typeof field.value === "object" &&
            Object.keys(field.value).length < 1
        ) {
            failed = true;
        } else if (!field.value || field.value === 0) {
            failed = true;
        }

        if (!failed) {
            const x = field.value.toString();
            if (x.trim() === "") failed = true;
        }

        if (failed) {
            field.isValid = false;
            field.validationMessages.push("This field is required.");
        }
        return field.isValid;
    },

    formatApplyName: (field: FormField, fieldSet?: FormField[]) => {
        const maxChars = 100;
        if (field.value.length > maxChars) {
            field.isValid = false;
            field.validationMessages.push("Only 100 characters allowed.");
        }
        return field.isValid;
    },

    formatReferName: (field: FormField, fieldSet?: FormField[]) => {
        const maxChars = 100;
        if (field.value.length > maxChars) {
            field.isValid = false;
            field.validationMessages.push("Only 100 characters allowed.");
        }
        return field.isValid;
    },

    formatPhone: (field: FormField, fieldSet?: FormField[]) => {
        // Based on https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
        const phoneRegExp = /^[1]?[2-9]\d{9}$/;
        if (!!field.value && !field.value.match(phoneRegExp)) {
            field.isValid = false;
            field.validationMessages.push(
                "Phone number should be numbers only, North America-based, and support messaging."
            );
        }
        return field.isValid;
    },

    formatEmail: (field: FormField, fieldSet?: FormField[]) => {
        const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const indeedEmailRegEx = /^.*[Ii][Nn][Dd][Ee][Ee][Dd][Ee][Mm][Aa][Ii][Ll].[Cc][Oo][Mm]/;

        const maxChars = 300;
        if (!!field.value && !emailRegEx.test(field.value)) {
            field.isValid = false;
            field.validationMessages.push("Email format is not correct.");
        }
        if (indeedEmailRegEx.test(field.value)) {
            field.isValid = false;
            field.validationMessages.push("Indeed emails are not permitted.");
        }
        if (field.value.length > maxChars) {
            field.isValid = false;
            field.validationMessages.push("Only 300 characters allowed.");
        }
        return field.isValid;
    },
};
